import {Button, CircularProgress, Stack} from '@mui/material';

export interface AdminQuestionReviewActionsProps {
  onNavigateToQuestionReview: () => void;
  onCountQuestions?: () => void;
  countLoading: boolean;
  showCountButton: boolean;
}

export default function AdminQuestionReviewActions({
  onNavigateToQuestionReview,
  onCountQuestions,
  countLoading,
  showCountButton,
}: AdminQuestionReviewActionsProps) {
  return (
    <Stack direction="row" spacing={2} sx={{width: '100%', justifyContent: 'center'}}>
      <Button
        variant="contained"
        onClick={onNavigateToQuestionReview}
        sx={{
          bgcolor: '#1B263B',
          '&:hover': {bgcolor: '#1B263B', opacity: 0.8},
          height: '56px',
          minWidth: 150,
        }}
      >
        Review Questions
      </Button>
      {showCountButton && onCountQuestions && (
        <Button
          variant="outlined"
          onClick={onCountQuestions}
          disabled={countLoading}
          sx={{
            borderColor: '#1B263B',
            color: '#1B263B',
            height: '56px',
            minWidth: 150,
            '&:hover': {borderColor: '#1B263B', bgcolor: 'rgba(27, 38, 59, 0.04)'},
          }}
        >
          {countLoading ? <CircularProgress size={20} /> : 'Count'}
        </Button>
      )}
    </Stack>
  );
}
